import { render, staticRenderFns } from "./StaffRoleDetail.vue?vue&type=template&id=df27dd9a&scoped=true"
import script from "./StaffRoleDetail.vue?vue&type=script&lang=js"
export * from "./StaffRoleDetail.vue?vue&type=script&lang=js"
import style0 from "./StaffRoleDetail.vue?vue&type=style&index=0&id=df27dd9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df27dd9a",
  null
  
)

export default component.exports